<script setup lang="ts">
import { computed } from 'vue';
import { useComponentComposable } from '@/components/useComponentComposable';

interface Props {
  text: string;
  tooltip: string;
  label?: string;
  maxCharacters: number;
}
const props = withDefaults(defineProps<Props>(), {
  maxCharacters: 200
});

const { renderHTMLContent } = useComponentComposable();

const separateCharacters = computed(() => {
  const margin = (props.text?.match(/\n\n/g) || []).length;
  let text = props.text?.slice(0, props.maxCharacters - margin);
  if (text?.length < props.text?.length) {
    text += '...';
  }
  return text;
});

function removeHtmlTags(html: string) {
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent ?? div.innerText ?? '';
  return text.trim();
}
</script>
<template>
  <div class="long-paragraph-component white-space-break">
    <div v-if="maxCharacters > text?.length">
      <div class="flex">
        <span class="font-bold" v-if="label">{{ label }}: </span><renderHTMLContent :data="separateCharacters" htmlElement="div"></renderHTMLContent>
      </div>
    </div>
    <div v-else class="text-content white-space-break">
      <div
        v-tooltip.bottom="{
          value: removeHtmlTags(tooltip)
        }"
        class="flex"
      >
        <span class="font-bold" v-if="label">{{ label }}: </span><renderHTMLContent :data="separateCharacters" htmlElement="div"></renderHTMLContent>
      </div>
    </div>
  </div>
</template>
